<mini-widget-icon-card
    iconImage="assets/icons/contract_optim.svg"
    [color]="statusColor"
    [isLoading]="loading"
    [clickable]="true"
    (click)="goToOptimizationsPage()"
>
    <div class="text-content">
        <strong>{{ 'WIDGET.MINI_CONTRACT_OPTIMIZATION.TITLE' | translate }}</strong>
        <h1 class="main-content" [coloredTextColor]="statusColor">
            <span class="kpi">
                {{ potentialSavings | localnumber: 0 : 0 }}
            </span>
            <span
                class="kpi-unit"
                [innerHTML]="'WIDGET.MINI_CONTRACT_OPTIMIZATION.UNIT' | translate: { vatMode: 'STUFF.' + vatMode | translate }"
            ></span>
        </h1>
        <p class="sub-content">{{ 'WIDGET.MINI_CONTRACT_OPTIMIZATION.OF_POTENTIAL_SAVINGS' | translate }}</p>
    </div>
</mini-widget-icon-card>
